import { AiOutlineCloudUpload } from 'react-icons/ai';
import { map } from 'lodash';

const DropzoneComponent = (props) => {
  const { acceptedFiles, getRootProps, getInputProps, fileRejectionItems } = props;

  const files = map(acceptedFiles, file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  return (
    <div className='gm-dropzone-files-container'>
      <section className="gm-dropzone-container">
        <div {...getRootProps({ className: 'gm-dropzone' })}>
          <AiOutlineCloudUpload size={60} />
          <div>
            <input {...getInputProps()} />
            <p>Arrastra y suelta el archivo aquí o <br></br>
            <span>haz click aquí</span> para seleccionar el archivo
             </p>
          </div>
        </div>
      </section>
      <div className='gm-files-container'>
        {fileRejectionItems?.length ? (
        <div className=''>
          <ul>{fileRejectionItems}</ul>
        </div>
        ) : ""}
        {acceptedFiles?.length ? <ul>{files}</ul> : ''}
      </div>
    </div>
  );
}

export default DropzoneComponent;